
import { ChatMessage } from "@/lib/types";

/**
 * Formats raw message data from Supabase into the application's ChatMessage type
 * @param messagesData Raw message data from database
 * @param channelId Current channel ID
 * @returns Formatted messages array
 */
export function formatMessages(messagesData: any[], channelId: string): ChatMessage[] {
  return messagesData.map(message => {
    // Handle potential null or invalid user data from database
    let messageUser = undefined;
    
    // Check if user data exists and is a valid object (not an error)
    if (message.user && 
        typeof message.user === 'object' && 
        'id' in message.user && 
        message.user.id && 
        'username' in message.user && 
        message.user.username && 
        'avatar_id' in message.user && 
        message.user.avatar_id) {
      messageUser = {
        id: message.user.id,
        username: message.user.username,
        avatarId: message.user.avatar_id,
        bio: "",
        isSubscriber: false,
        isDonator: false
      };
    }

    // Handle potential null or invalid reply message user from database
    let replyMessage = undefined;
    if (message.replyToMessage) {
      let replyUser = undefined;
      
      // Check if the reply message has a valid user object
      if (message.replyToMessage.user && 
          typeof message.replyToMessage.user === 'object' && 
          'username' in message.replyToMessage.user &&
          message.replyToMessage.user.username) {
        replyUser = {
          id: message.replyToMessage.user_id,
          username: message.replyToMessage.user.username,
          avatarId: 1, // Default
          bio: "",
          isSubscriber: false,
          isDonator: false
        };
      }

      replyMessage = {
        id: message.replyToMessage.id,
        channelId: channelId,
        userId: message.replyToMessage.user_id,
        content: message.replyToMessage.content,
        isPinned: false,
        isDeleted: false,
        mentions: [],
        createdAt: "",
        updatedAt: "",
        user: replyUser
      };
    }

    // Ensure mentions is always a string array
    let mentionsArray: string[] = [];
    if (message.mentions) {
      if (Array.isArray(message.mentions)) {
        mentionsArray = message.mentions as string[];
      } else if (typeof message.mentions === 'object') {
        // Try to convert JSON object to array if possible
        try {
          const parsed = JSON.stringify(message.mentions);
          mentionsArray = JSON.parse(parsed);
          if (!Array.isArray(mentionsArray)) mentionsArray = [];
        } catch {
          mentionsArray = [];
        }
      }
    }

    return {
      id: message.id,
      channelId: message.channel_id,
      userId: message.user_id,
      content: message.content,
      isPinned: message.is_pinned || false,
      isDeleted: message.is_deleted || false,
      deletedBy: message.deleted_by,
      replyTo: message.reply_to,
      mentions: mentionsArray,
      createdAt: message.created_at,
      updatedAt: message.updated_at,
      user: messageUser,
      reactions: message.reactions ? message.reactions.map((reaction: any) => ({
        id: reaction.id,
        messageId: message.id,
        userId: reaction.user_id,
        emoji: reaction.emoji,
        createdAt: "", // Not available in the response
      })) : [],
      replyToMessage: replyMessage
    };
  });
}
